import { render, staticRenderFns } from "./mokuai38.vue?vue&type=template&id=0f5b5824&"
import script from "./mokuai38.vue?vue&type=script&lang=js&"
export * from "./mokuai38.vue?vue&type=script&lang=js&"
import style0 from "./mokuai38.vue?vue&type=style&index=0&id=0f5b5824&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports